/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { RepresentationModelObject } from '../models/representation-model-object';

@Injectable({
  providedIn: 'root',
})
export class RootControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getLinks
   */
  static readonly GetLinksPath = '/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLinks()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinks$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<RepresentationModelObject>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      RootControllerService.GetLinksPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/hal+json',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<RepresentationModelObject>;
        })
      );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLinks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLinks(
    params?: {},
    context?: HttpContext
  ): Observable<RepresentationModelObject> {
    return this.getLinks$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<RepresentationModelObject>) =>
          r.body as RepresentationModelObject
      )
    );
  }
}
